module.exports = __webpack_public_path__ + "img/home-graphic.db412a6b.svg";